<template>
    <div class="share-file dialog-wraper">
        <div v-if="!linking" class="share-wraper">
            <p v-if="!issuper">{{$t('MemberTip')}}</p>
            <template v-if="utype == 'creator' || utype == 'admin'">
                <div class="file-share-box">
                    <div class="link-body">
                        <div :title="copyData" :class="`share-url select-all nowrap ${error ? 'link-error' : ''}`">{{error || copyData}}</div>
                        <div v-if="!error" v-clipboard="copyData" @success="copySuccess" @error="copyError" class="copy-link" v-t="'Copy'"></div>
                        <div v-if="error" class="copy-link" v-t="'Copy'"></div>
                    </div>
                </div>
                <div class="share-permission-wraper">
                    <div class="link-permission-box">
                        <span class="link-label nowrap">{{$t('InviteTo')}}</span>
                        <el-dropdown class="link-nowrap" trigger="click" placement="bottom-start" @command="(e) => switchTab(e,'userType')">
                            <span class="link-permission">
                                <span class="link-permission-tip nowrap">{{$t(`M${userType}`)}}</span><i class="components-icons components-icons-down"><span class="path1"></span></i></span>
                            <el-dropdown-menu 
                                slot="dropdown" 
                                :visible-arrow="false"
                                class="list-actions">
                                <el-dropdown-item command="member" :class="['list-action-item',userType === 'member' ? 'checked' : '']">
                                    <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Mmember')}}</div>
                                </el-dropdown-item>
                                <el-dropdown-item command="read_member" :class="['list-action-item',userType === 'read_member' ? 'checked' : '']">
                                    <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Mread_member')}}</div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                        <span class="link-expire">
                            <span class="link-expire-tip nowrap">{{$t('Expire')}}</span>
                            <el-dropdown trigger="click" placement="bottom-end"  @command="(e) => switchTab(e,'expire')">
                                <span class="link-expire-date">{{$t(expireTxt)}}<i class="components-icons components-icons-down"><span class="path1"></span></i></span>
                                <el-dropdown-menu 
                                    slot="dropdown" 
                                    :visible-arrow="false"
                                    class="list-actions">
                                    <el-dropdown-item :command="0" :class="['list-action-item',expire == 0 ? 'checked' : '']">
                                        <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Thdays')}}</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item :command="1" :class="['list-action-item',expire == 1 ? 'checked' : '']">
                                        <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Sedays')}}</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item :command="2" :class="['list-action-item',expire == 2 ? 'checked' : '']">
                                        <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Thtdays')}}</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item :command="3" :class="['list-action-item',expire == 3 ? 'checked' : '']">
                                        <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Forever')}}</div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </span>
                    </div>

                    <div v-if="false" class="invite-box">
                        <div class="invite-entry">
                            <span @click="invite" class="invite-text">
                            <span class="add-icon"><span class="components-icons-box"><i class="components-icons components-icons-add"><span class="path1"></span></i></span></span> {{$t('SelectContacts')}}</span>
                        </div>
                    </div>
                </div>
            </template>


            <div class="link-members-box" v-scroller="onscroll" @scroll="handelscroll" ref="scrollwraper">
                <template>
                    <div class="file-share-member-item" v-for="item in members" :key="item.key">
                        <div class="member-avatar-box">
                            <div class="member-avatar avatar-marginRight">
                                <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                    <img :src="item.avatar" class="el-tooltip item" style="width: 24px; height: 24px;">
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="member-name-box"><div class="nowrap" :title="item.name" style="cursor: default;">{{item.name}}</div></div>
                        <div class="member-extension">
                            <span 
                                v-if="(utype !== 'creator' && utype !== 'admin') || item.role == 'creator' || (utype == 'admin' && item.role == 'admin')" 
                                class="member-permission-select">{{$t(`M${item.role}`)}}</span>
                            <el-dropdown 
                                v-if="(utype === 'creator' && item.role !== 'creator') || (utype == 'admin' && item.role != 'admin' && item.role != 'creator')" 
                                :ref="`dropdown${item.id}`" 
                                @visible-change="(e) => dropchange(e,item.id)" 
                                trigger="click" 
                                placement="bottom-end" 
                                @command="(e) => switchMember(e,item.id)">
                                <span class="member-permission-select">{{$t(`M${item.role}`)}}<span class="components-icons-box"><i class="components-icons components-icons-down"><span class="path1"></span></i></span></span>
                                <el-dropdown-menu 
                                    slot="dropdown" 
                                    :visible-arrow="false"
                                    class="list-actions member-permission">
                                    <el-dropdown-item v-if="utype == 'creator'" command="admin" :class="['list-action-item',item.role == 'admin' ? 'checked': '']">
                                        <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Madmin')}}</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item command="member" :class="['list-action-item',item.role == 'member' ? 'checked': '']">
                                        <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Mmember')}}</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item command="read_member" :class="['list-action-item',item.role == 'read_member' ? 'checked': '']">
                                        <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Mread_member')}}</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item :class="[`list-action-item`]">
                                        <div class="list-action-inner stop-share"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Remove')}}</div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </template>
                <div v-if="memberLoading" class="member-loading">{{$t('Loading')}}</div>
            </div>
        </div>
        <div class="share-wraper" v-if="linking" >
            <loading />
        </div>
    </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import {linkSetting,switchPermission,removeMember} from '@/store/service/team'
import Loading from '@/components/Loading'
export default {
    data(){
        return {
            error: '',
            expire: 0,
            userType: 'member',
            currentDrop: 0
        }
    },
    components:{
        Loading
    },
    created(){
        let tid = this.$route.params.tid
        let {uinit} = this.dialogData
        if (!uinit) {
            this.inviteLink(tid)
            this.INIT_MEMBERS()
        }else if(uinit == 'update'){
            this.INIT_MEMBERS()
        }
        this.loadMembers({tid})

        
    },
    computed:{
        ...mapState([
            'dialogData',
            'dialogTitle',
            'dialogIco',
            'extraData'
        ]),
        ...mapState('team',[
            'linking',
            'currentTeam',
            'memberLoading',
            'members',
            'mMax'
        ]),
        copyData(){
            return this.currentTeam.invite_url || 'error'
        },
        utype(){
            return this.currentTeam.member_role
        },
        expireDate(){
            let dates = [3,7,30,0]
            return dates[this.expire]
        },
        expireTxt(){
            let txts = ['Thdays','Sedays','Thtdays','Forever']
            return txts[this.expire]
        },
        issuper(){
            return this.utype == 'admin' || this.utype == 'creator'
        }
    },
    methods:{
        ...mapActions('team',[
            'inviteLink',
            'loadMembers'
        ]),
        ...mapMutations([
            'SHOW_DIALOG',
            'DIALOG_INIT',
            'SET_EXTRA'
        ]),
        ...mapMutations('team',[
            'UPDATE_MEMBER',
            'SAVE_TEAM',
            'INIT_MEMBERS'
        ]),
        onscroll(){
            this.$refs.scrollwraper.click()
            this.loadMembers({tid:this.$route.params.tid})
        },
        handelscroll(e){
            this.currentDrop ? this.$refs[`dropdown${this.currentDrop}`][0].hide() : ''
        },
        dropchange(e,id){
            this.currentDrop = e ? id : 0
        },
        switchTab(e,type){
            if (e != undefined) {
                this[type] = e
                let {tid} = this.dialogData
                linkSetting({
                    groupid: tid,role: this.userType,expiretime: this.expireDate
                },({status,data}) => {
                    if (status >= 200 && status < 300) {
                        this.$message.success(this.$t('Success'))
                    }else{
                        this.$message.error(this.$t(data.result))
                    }
                })
            }
            
        },
        back(flag){
            this.SHOW_DIALOG({
                title: `${this.$t('TeamMember')}`,
                size: 'large',
                current: 'TeamShare',
                header: false,
                dialogData:{
                    tid: this.$route.params.tid,
                    role: this.currentTeam.member_role,
                    uinit: flag
                }
            })
        },
        switchMember(crole,id){
            let {tid,role} = this.dialogData
            if (crole) {
                switchPermission({
                    groupid: tid,
                    id,
                    role: crole
                },({status,data}) => {
                    if (status == 200) {
                        this.UPDATE_MEMBER({
                            role: crole,
                            id
                        })
                        this.$message.success(this.$t('Success'))
                    }else{
                        this.$message.error(this.$t(data.result))
                    }
                })
            }else{
                removeMember({
                    groupid: tid,
                    memberid:id
                },({status,data}) => {
                    if (status == 200) {
                        this.mMax ? this.UPDATE_MEMBER({id}) : this.loadMembers({tid,init: true})
                        let ivlink = this.currentTeam.invite_link
                        let member_count = ivlink.membercount - 1
                        this.SET_EXTRA({
                            endTitle: `(${member_count}/${ivlink.membercountlimit})`
                        })
                        ivlink.membercount = member_count
                        this.SAVE_TEAM({
                            invite_link: ivlink,
                            member_count
                        })
                        this.$message.success(this.$t('Success'))
                    }else{
                        this.$message.error(this.$t(data.result))
                    }
                })
            }
            
        },
        copySuccess(e){
            this.$message.success(this.$t('Copylink'))

        },
        copyError(){
            this.$message.success(this.$t('Copyerror'))
        },
        invite(){
            this.SHOW_DIALOG({
                current: 'Contact',
                header: true,
                size: 'large',
                dialogData:{
                    ...this.dialogData,
                    from: 'TeamShare'
                }
            })
        }
    },
    watch:{
        currentTeam(cur){
            if (cur.invite_link) {
                let dates = [3,7,30,0]
                let {role,settingtime} = cur.invite_link
                this.expire = dates.indexOf(settingtime)
                this.userType = role
            }
        }
    }
}
</script>

<style>
.link-label {
    margin-right: 6px;
}
.member-loading{
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/team/TeamShare.vue